import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { DxTreeViewComponent } from 'devextreme-angular';
import { Apiservice } from '../../../services/api.service';
import { alert, confirm } from 'devextreme/ui/dialog';
import { NicaAnagraficaComponent } from '../../nica-anagrafica/nica-anagrafica.component';
import { ComponentService } from '../../../services/component.service';
import { messagefromComponent } from '../../../class/appinterface';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { costantValue } from '../../../services/forms-template.service';
import { data } from 'jquery';
import { NewNicaFormComponent } from '../../nica-form/new-nica-form.component';
import { IPartner } from '../../../views/crm/interfaces';
import { Utenteservice } from '../../../services/utente.service';
import { environment } from '../../../../environments/environment';


@Component({
  selector: 'app-crm-dettagli-procedure-contatti',
  templateUrl: './crm_dettagli_procedure_contatti.component.html',
  styleUrls: ['./crm_dettagli_procedure_contatti.component.css']
})
export class CrmDettagliProcedureContattiComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild("treeView", { static: false }) treeView!: DxTreeViewComponent
  @ViewChild("anagrafica", { static: false }) anagrafica!: NicaAnagraficaComponent
  @ViewChild("infoGenerali", { static: false }) infoGenerali!: NewNicaFormComponent
  @Input() tooltipInfo: boolean = true
  @Input() queryString = ''
  @Input() filterEditor = ''
  @Input() detailVisible: boolean = true;
  @Input() classeTreeView: string = ''
  @Input() classeTreeDetail: string = ''
  @Input() heightTree: number | undefined = 300
  @Input() widthTree: number | undefined
  @Input() heightDetail: string | undefined = '300'
  @Input() widthDetail: string | undefined
  @Input() focusStateEnabled: boolean = true;
  @Input() btnInfo: boolean = false
  @Input() isPopUp: boolean = false
  @Input() collassabile: boolean = true;
  @Input() dataRelated: { [key: string]: any } = {}
  @Input() costantValues: costantValue[] = [];
  @Input() sedeSelezionata: { [key: string]: any }
  @Output() onAllEvent: EventEmitter<any> = new EventEmitter<any>()
  isAmministrazione: boolean;
  stateItemSelected: string = "Informazioni Generali"
  serviceProcedure: string;
  filterKey
  public datiProcedure: any = [];
  public currentItem: any;
  moment = require('moment');
  CustomButtonSetForm: any[] = [
    {
      location: 'after',
      widget: 'dxButton',
      locateInMenu: 'after',
      stylingMode: 'contains',
      text: 'Aggiungi Diario',
      icon: 'dx-icon-plus',
      hint: 'Aggiungi Diario',
      visible: true,
      disabled: false,
      id: 'addNota'
    }
  ]
  procedure: any = []
  loading: boolean = true
  tooltipData: { [key: string]: any } = {}
  partnerData: IPartner = {
    isPartner: false,
    isSegreteria: false,
    id: null
  }
  private $distruggi: Subject<void> = new Subject<void>()
  constructor(private apiService: Apiservice, private cdf: ChangeDetectorRef, private componentService: ComponentService, private userLogged: Utenteservice) {
    this.loading = true
  }
  ngAfterViewInit(): void {
    // this.loading = false
    // this.cdf.detectChanges()
  }
  ngOnDestroy(): void {
    this.$distruggi.next()
    this.$distruggi.complete()
    this.$distruggi.unsubscribe()
  }

  ngOnInit(): void {
    this.isAmministrazione =
      (
        this.userLogged.InfoDatiUtenteConnesso.userName === environment.EMAIL_AMMINISTRAZIONE &&
        this.userLogged.InfoUtenteConnesso.tipoUtente == 11
      ) ? true : false
    if (this.queryString && this.queryString !== '') {
      if (this.sedeSelezionata && this.sedeSelezionata.Cod) {
        this.queryString += `?CodSede=${this.sedeSelezionata.Cod}`
      }
      this.getProcedureContatti()
    }
    this.componentService.castMessage.pipe(takeUntil(this.$distruggi)).subscribe((messaggio: messagefromComponent) => {
      console.log(messaggio)
      return this.processaMessaggio(messaggio)
    })
  }

  async getProcedureContatti() {
    this.loading = true
    this.cdf.detectChanges()
    await this.apiService.GetApiRest(`getAllProcedureByContatto${this.queryString}`).then((res) => {
      const dati = res as any[];
      return this.setExpandedForParents(dati);
    }).catch((errore) => {
    })
  }

  async getProcedure() {
    try {
      const cod = this.dataRelated.Cod
      const response = await this.apiService.GetApiRest(`getAllProcedureByContatto/${cod}`)
      this.procedure = response
    } catch (error) {
      console.error('Errore durante il recupero delle procedure:', error);
    }
  }

  processaMessaggio(messaggio: messagefromComponent) {
    if (messaggio && messaggio.destComponent === this.constructor.name) {
      if (messaggio.traceMessage === 'reload') {
        this.getProcedureContatti()
      }
    }
    return
  }
  riorganizzaArray(array) {
    let risultato = [];
    array.sort((a, b) => {
      return a.id - b.id;
    });
    array.sort((a, b) => {
      if (a.CodSede > b.CodSede) return -1;
      if (a.CodSede < b.CodSede) return 1;
      return 0;
    });
    array.sort((a, b) => {
      if (a.procedura_attiva == 3) a.procedura_attiva = 0
      if (a.procedura_attiva > b.procedura_attiva) return -1;
      if (a.procedura_attiva < b.procedura_attiva) return 1;
      return 0;
    });
    let codiciGestiti = new Set();

    array.forEach(obj => {
      if (!codiciGestiti.has(obj.CodSede)) {
        risultato.push({
          CodSede: obj.CodSede,
          Ind: obj.Ind,
          Prov: obj.Prov,
          isTitolo: true
        });
        codiciGestiti.add(obj.CodSede);
      }
      risultato.push(obj);
    });
    console.log(risultato)
    return risultato;
  }

  checkDisabilitati(dati) {
    return dati.map((procedura) => {
      procedura.stato = procedura.procedura_attiva
      procedura.moduli = procedura.moduli.map((modulo) => {
        modulo.stato = procedura.procedura_attiva
        return modulo
      })
      return procedura
    })
  }
  setExpandedForParents(items: any[]): boolean {
    //info crea un ciclo dove gli item che hanno i figli (item.moduli) sono espansi 
    //console.log(this.riorganizzaArray(items))

    if (!items || items.length === 0) {
      this.datiProcedure = [];
      this.currentItem = null;
      this.loading = false;
      this.cdf.detectChanges();
      return true;
    }
    
    let array = this.checkDisabilitati(items)
    array = this.riorganizzaArray(array)
    array.forEach((item, index) => {
      if (item.isTitolo) {
        item.selected = false
        item.expanded = false;
      } else {
        if (index === 1 && !this.currentItem) {
          item.selected = true
          this.currentItem = item
          if (this.anagrafica) {
            this.costantValues = [
              {
                key: 'Contatto',
                value: this.dataRelated.Cod
              },
              {
                key: 'Sede',
                value: this.currentItem.CodSede
              },
            ]
            this.anagrafica.refresh()
          }
        } else {
          if (this.currentItem && this.currentItem.id === item.id) {
            item.selected = true
            this.currentItem = item
            if (this.anagrafica) {
              this.costantValues = [
                {
                  key: 'Contatto',
                  value: this.dataRelated.Cod
                },
                {
                  key: 'Sede',
                  value: this.currentItem.CodSede
                },
              ]
              this.anagrafica.refresh()
            }
          } else {
            item.moduli.forEach((modulo, index) => {
              if (this.currentItem && this.currentItem.id === modulo.id) {
                item.moduli[index].selected = true
                this.currentItem = item.moduli[index]
              }
            })
          }

        }
        if (item.moduli && item.moduli.length > 0) {
          item.expanded = false;
        }
      }
    });
    //console.log(array)
    this.datiProcedure = array

    // if (this.anagrafica) {
    this.costantValues = [
      {
        key: 'Contatto',
        value: this.dataRelated.Cod
      },
      {
        key: 'Sede',
        value: this.currentItem !== undefined ? this.currentItem.CodSede : null
      },
    ]
    // this.anagrafica.refresh()
    // }
    this.loading = false
    this.cdf.detectChanges()
    return true
  }

  //info in questa funzione se l'item è espanso, allora avvia il collapseItem()
  onTreeItemClick(e: any) {
    //Verifico se la procedura o il modulo selezionato è disabilitato e cambio il valore di stateItemSelected
    if (e.itemData.CodModulo !== 0 && e.itemData.procedura_attiva === 0) {
      this.stateItemSelected = `Informazioni Generali <h4 class="text-danger text-info">(Procedura Opzionale Disabilitata)</h4>`
    }
    // else if (e.itemData.CodModulo !== 0 && e.itemData.procedura_attiva === 2) {
    //   this.stateItemSelected = `Informazioni Generali <h4 class="text-warning text-info">(Procedura Opzionale In Attesa)</h4>`
    // } 
    else if (e.itemData.CodModulo === 0 && e.itemData.stato === 0) {
      this.stateItemSelected = `Informazioni Generali <h4 class="text-danger text-info">(Procedura Principale Disabilitata)</h4>`
    } else if (e.itemData.CodModulo === 0 && e.itemData.stato === 3) {
      this.stateItemSelected = `Informazioni Generali <h4 class="text-danger text-info">(Procedura Principale Disdetta)</h4>`
    }
    // else if (e.itemData.CodModulo === 0 && e.itemData.stato === 2) {
    //   this.stateItemSelected = `Informazioni Generali <h4 class="text-warning text-info">(Procedura Principale In Attesa)</h4>`
    // } 
    else {
      this.stateItemSelected = "Informazioni Generali"
    }

    this.serviceProcedure = e.itemData.CodModulo === 0 ? 'CrmProcedureDetailForm' : 'CrmProcedureMasterDetailForm'
    this.filterKey = `/${e.itemData.id}`
    if (e.itemData && e.itemData.isTitolo === undefined) {
      this.currentItem = e.itemData;
      const key = e.itemData.id;
      if (this.collassabile) {
        if (e.node.expanded) {
          this.treeView.instance.collapseItem(key);
        } else {
          this.treeView.instance.expandItem(key);
        }
      }
      if (this.anagrafica) {
        this.costantValues = [
          {
            key: 'Contatto',
            value: this.dataRelated.Cod
          },
          {
            key: 'Sede',
            value: this.currentItem.CodSede
          },
        ]
        this.anagrafica.refresh()
      }

      if (this.infoGenerali) {
        this.cdf.detectChanges()
        this.infoGenerali.getData()
        // this.infoGenerali.formRefreshGridDataSource()
      }
    }
    return

  }

  syncSelection(treeView: DxTreeViewComponent['instance']) {
    const selectedItem = treeView.getSelectedNodes()
      .map((node) => node.itemData);
    if (!this.currentItem) this.currentItem = selectedItem[0];
    this.filterKey = `/${this.currentItem.id}`
    this.serviceProcedure = this.currentItem.CodModulo === 0 ? 'CrmProcedureDetailForm' : 'CrmProcedureMasterDetailForm'
    //Verifico se la procedura o il modulo selezionato è disabilitato e cambio il valore di stateItemSelected
    if (this.currentItem.CodModulo !== 0 && this.currentItem.procedura_attiva === 0) {
      this.stateItemSelected = `Informazioni Generali <h4 class="text-danger text-info">(Procedura Opzionale Disabilitata)</h4>`
    }
    // else if (this.currentItem.CodModulo !== 0 && this.currentItem.procedura_attiva === 2) {
    //   this.stateItemSelected = `Informazioni Generali <h4 class="text-warning text-info">(Procedura Opzionale In Attesa)</h4>`
    // } 
    else if (this.currentItem.CodModulo === 0 && this.currentItem.stato === 0) {
      this.stateItemSelected = `Informazioni Generali <h4 class="text-danger text-info">(Procedura Principale Disabilitata)</h4>`
    } else if (this.currentItem.CodModulo === 0 && this.currentItem.stato === 3) {
      this.stateItemSelected = `Informazioni Generali <h4 class="text-danger text-info">(Procedura Principale Disdetta)</h4>`
    }
    // else if (this.currentItem.CodModulo === 0 && this.currentItem.stato === 2) {
    //   this.stateItemSelected = `Informazioni Generali <h4 class="text-warning text-info">(Procedura Principale In Attesa)</h4>`
    // } 
    else {
      this.stateItemSelected = "Informazioni Generali"
    }
    this.cdf.detectChanges()
  }

  async emittendButtonPush(event) {
    if (event.name === 'beforSave') {
      const formData = event.formData
      if (formData) {
        let rate: number[] = [];
        for (let i = 1; i <= 4; i++) {
          const value = formData[`rata${i}`];
          if (value !== null && value !== '' && value !== undefined) {
            rate.push(Number(value));
          }
        }
        if (rate.length > 0) {
          const rateUniche = Array.from(new Set(rate)).sort((a, b) => a - b);
          formData.rate = rateUniche
            .map((n) => n < 10 ? `0${n}` : `${n}`)
            .join('§');

        } else {
          formData.rate = ''
        }
        const dataScadenza = formData.dataScadenza
        const dataAttivazione = formData.dataAttivazione

        if (dataAttivazione && dataScadenza) {
          if (!this.moment(dataAttivazione).isBefore(this.moment(dataScadenza))) {
            event.cancel = true
            event.cancella = true
            event.isValid = false
            return alert('Seleziona le date di attivazione e scadenza correttamente', 'Attenzione')
          }
        }
      }

    }
    if (event.name === 'formDataInit') {
      const formData = event.formData
      if (formData) {
        if (formData.rate && formData.rate !== '') {
          const arrRate = formData.rate.split('§')
          for (let i = 1; i <= 4; i++) {
            formData[`rata${i}`] = arrRate[i - 1]
          }
        }
      }
    }

    if (event.name === 'submittedEditOk') {
      await this.getProcedureContatti()
      this.cdf.detectChanges()
    }

    if (event.name === "addNota") {
      let newGuid = Math.random().toString().replace("0.", "")
      const newDataToSend = {
        service: 'crmDiarioAttivitaContatto',
        api: 'diario',
        masterKey: 'id',
        api_eventt: true,
        type: "simple",
        remoteOperation: true,
        dataJson: {
          CodContatto: this.dataRelated.Cod,
          DataInserimento: this.moment().format('YYYY-MM-DD HH:MM'),
          CodIdMaster: this.currentItem.id,
        },
      }
      console.log(newDataToSend)
      this.componentService.setNewPopUp(newGuid, 'NewNicaFormComponent', null, '500', null, newDataToSend, false, true, 'Aggiungi Nota', 'top')
      this.componentService.outputComponent.subscribe((res) => {
        if (res.name === 'return' && res.guid == newGuid) {
          return this.componentService.destroyCurrentOpenPopUpByGuid(newGuid);
        }
        if (res.name === 'submittedInsertOk' && res.guid == newGuid) {
          return this.componentService.destroyCurrentOpenPopUpByGuid(newGuid);
        }
        if (res.name === 'submittedEditOk' && res.guid == newGuid) {
          return this.componentService.destroyCurrentOpenPopUpByGuid(newGuid);
        }

        // this.onAllEventGrid(res)
      });
    }
  }

  async onClickBtn(event, currentItem) {
    let dataToSend = {}
    if (event && event.element && event.element.name) {
      switch (event.element.name) {
        case 'editBtn':
          const service = this.currentItem.CodModulo === 0 ? 'CrmProcedureDetailForm' : 'CrmProcedureMasterDetailForm'
          dataToSend = {
            id: "contatti",
            service: service,
            masterKey: 'id',
            api: "getmasterprocedure",
            api_rest: true,
            type: "simple",
            disableEditForm: false,
            isEdit: true,
            nCol: "1",
            remoteOperation: true,
            queryString: `/${this.currentItem.id}`,
            dataJson: this.currentItem,
            CustomButtonSetForm: this.CustomButtonSetForm
          }
          this.apriPopUp('NewNicaFormComponent', dataToSend, `Modifica ${this.currentItem.CodModulo === 0 ? 'Procedura Principale' : 'Procedura Opzionale'}`, this.currentItem.CodModulo === 0 ? '500' : '500')
          break;
        case 'addmoduloBtn':
          let msg = ''
          if (this.currentItem.procedura_attiva !== 0) {
            if (this.currentItem.accettaModuli === 1) {
              dataToSend = {
                id: "contatti",
                service: 'CrmProcedureMasterDetailForm',
                masterKey: 'id',
                api: "getmasterprocedure",
                api_rest: true,
                type: "simple",
                disableEditForm: false,
                isEdit: false,
                nCol: "1",
                remoteOperation: true,
                queryString: '',
                dataJson: {
                  CodContatto: this.dataRelated.Cod,
                  CodProcedura: this.currentItem.CodProcedura,
                  CodSede: this.currentItem.CodSede,
                  id_master_procedura: this.currentItem.id,
                  procedura_attiva: 1,
                  quantita: 1,
                  dataAttivazione: this.moment().month(0).date(1).format('YYYY-MM-DD'),
                  dataInstallazione: this.moment().format('YYYY-MM-DD'),
                  // dataScadenza: this.currentItem.dataScadenza
                  dataScadenza: this.moment().month(11).date(31).format('YYYY-MM-DD')

                },
                CustomButtonSetForm: this.CustomButtonSetForm
              }
              this.apriPopUp('NewNicaFormComponent', dataToSend, 'Aggiungi Procedura Opzionale', '900')
              break
            } else {
              msg = 'La procedura non accetta moduli, non è possibile inserire moduli'
            }
          } else {
            msg = 'Procedura disattivata, non è possibile inserire nuovi moduli'
          }
          alert(msg, 'Attenzione')
          break;
        case 'disabilitaBtn':
          confirm(`Sei sicuro di voler disabilitare la procedura selezionata?`, 'Attenzione').then((conferma) => {
            if (conferma) {
              this.currentItem.procedura_attiva = 0
              this.apiService.PutApiRest(`getmasterprocedure/${this.currentItem.id}`, this.currentItem).then((response) => {
                this.getProcedureContatti()
              }).catch((errore) => {
                alert(`Errore nella disabilitazione della procedura selezionata`, 'Errore')
              });
            } else {
              return
            }
          })
          break
        case 'abilitaBtn':
          confirm(`Sei sicuro di voler abilitare la procedura selezionata?`, 'Attenzione').then((conferma) => {
            if (conferma) {
              this.currentItem.procedura_attiva = 1
              this.apiService.PutApiRest(`getmasterprocedure/${this.currentItem.id}`, this.currentItem).then((response) => {
                this.getProcedureContatti()
              }).catch((errore) => {
                alert(`Errore nell'abilitazione della procedura selezionata`, 'Errore')
              });
            } else {
              return
            }
          })
          break
        case 'addproceduraBtn':
          console.log(this.dataRelated)

          dataToSend = {
            id: "contatti",
            service: 'CrmProcedureDetailForm',
            masterKey: 'id',
            api: "getmasterprocedure",
            api_rest: true,
            type: "simple",
            disableEditForm: false,
            isEdit: false,
            nCol: "1",
            remoteOperation: true,
            queryString: '',
            dataJson: {
              CodContatto: this.dataRelated.Cod,
              CodModulo: 0,
              id_master_procedura: 0,
              procedura_attiva: 1,
              quantita: 1,
              dataAttivazione: this.moment().month(0).date(1).format('YYYY-MM-DD'),
              dataInstallazione: this.moment().format('YYYY-MM-DD'),
              dataScadenza: this.moment().month(11).date(31).format('YYYY-MM-DD')
            },
            CustomButtonSetForm: this.CustomButtonSetForm
          }
          this.apriPopUp('NewNicaFormComponent', dataToSend, 'Aggiungi Procedura Principale', '900')
          break
        case 'riepilogoProcedura':
          await this.getProcedure()
          if (this.procedure.length > 0) {
            dataToSend = {
              procedura: this.procedure
            }
            this.apriPopUp('RiepilogoProceduraComponent', dataToSend, 'Riepilogo Procedura Principale', '1300')
          } else {
            alert('Non ci sono procedure da visualizzare', 'Attenzione')
          }
          break
        case 'eliminaProcedura':
          console.log('stampo event per elimina procedura', this.currentItem)
          let text = this.currentItem.CodModulo !== 0 ? 'il Modulo selezionato ?' : 'la Procedura selezionata?'
          confirm(`Sei sicuro di voler eliminare ${text}`, 'Attenzione').then((conferma) => {
            if (conferma) {
              this.currentItem.procedura_attiva = 1
              this.apiService.DeleteApiRest(`getmasterprocedure/${this.currentItem.id}`,).then(() => {
                this.currentItem = null
                this.getProcedureContatti()
              }).catch((errore) => {
                alert(`Errore inatteso, riprova più tardi.`, 'Errore')
              });
            } else {
              return
            }
          })
          break;
        default:
          return
      }
    }

    return
  }
  
  onAllEventGrid(event) {
    
    let evento = event
    if (typeof evento === 'object') {
      evento.emitter = this.constructor.name
    } else {
      evento = {
        event: event,
        emitter: this.constructor.name
      }
    }
    // this.onAllEvent.emit(evento)
  }



  apriPopUp(componentname, dataToSend, titolo, width) {

    let guid = Math.random().toString().replace("0.", "")

    this.componentService.setNewPopUp(guid, componentname, null, width, null, dataToSend, false, true, titolo, 'top')
    this.componentService.outputComponent.subscribe((res) => {
      if (res.name === "addNota" && res.guid === guid) {
        let newGuid = Math.random().toString().replace("0.", "")
        const newDataToSend = {
          service: 'crmDiarioAttivitaContatto',
          api: 'diario',
          masterKey: 'id',
          api_rest: true,
          type: "simple",
          remoteOperation: true,
          dataJson: {
            CodContatto: this.dataRelated.Cod,
            DataInserimento: this.moment().format('YYYY-MM-DD HH:MM'),
            CodIdMaster: this.currentItem.id,
          },
        }
        console.log(newDataToSend)
        this.componentService.setNewPopUp(newGuid, 'NewNicaFormComponent', null, '500', null, newDataToSend, false, true, 'Aggiungi Nota', 'top')
        this.componentService.outputComponent.subscribe((res) => {
          if (res.name === 'return' && res.guid == newGuid) {
            this.componentService.destroyOutputComponent();

            return this.componentService.destroyCurrentOpenPopUpByGuid(newGuid);

          }
          if (res.name === 'submittedInsertOk' && res.guid == newGuid) {
            this.componentService.destroyOutputComponent();

            return this.componentService.destroyCurrentOpenPopUpByGuid(newGuid);
          }
          if (res.name === 'submittedEditOk' && res.guid == newGuid) {
            this.componentService.destroyOutputComponent();

            return this.componentService.destroyCurrentOpenPopUpByGuid(newGuid);
          }

          // this.onAllEventGrid(res)
        });
      }
      if (res.name === "btnCalcola" && res.guid == guid) {
        return this.calcolaRateo(res)
      }
      if (res.name === 'return' && res.guid == guid) {
        this.componentService.destroyOutputComponent();

        return this.componentService.destroyCurrentOpenPopUpByGuid(guid);
      }
      if (res.name === 'submittedInsertOk' && res.guid == guid) {
        if (this.anagrafica) {
          this.anagrafica.refresh()
        }
        this.getProcedureContatti()
        this.componentService.destroyOutputComponent();

        return this.componentService.destroyCurrentOpenPopUpByGuid(guid);
      }
      if (res.name === 'submittedEditOk' && res.guid == guid) {
        if (this.anagrafica) {
          this.anagrafica.refresh()
        }
        this.getProcedureContatti()
        this.componentService.destroyOutputComponent();

        return this.componentService.destroyCurrentOpenPopUpByGuid(guid);
      }
      if (res.name === 'beforSave' && res.guid == guid) {
        const formData = res.formData
        if (formData) {
          let rate: number[] = [];
          for (let i = 1; i <= 4; i++) {
            const value = formData[`rata${i}`];
            if (value !== null && value !== '' && value !== undefined) {
              rate.push(Number(value));
            }
          }
          if (rate.length > 0) {
            const rateUniche = Array.from(new Set(rate)).sort((a, b) => a - b);
            formData.rate = rateUniche.join('§');
          } else {
            formData.rate = ''
          }
          const dataScadenza = formData.dataScadenza
          const dataAttivazione = formData.dataAttivazione

          if (dataAttivazione && dataScadenza) {
            if (!this.moment(dataAttivazione).isBefore(this.moment(dataScadenza))) {
              res.cancel = true
              res.cancella = true
              res.isValid = false
              return alert('Seleziona le date di attivazione e scadenza correttamente', 'Attenzione')
            }
          }
        }

      }
      if (res.name === 'formDataInit' && res.guid == guid) {
        const formData = res.formData
        if (formData) {
          if (formData.rate && formData.rate !== '') {
            const arrRate = formData.rate.split('§')
            for (let i = 1; i <= 4; i++) {
              formData[`rata${i}`] = arrRate[i - 1]
            }
          }
        }
      }

      if (res.name === "formContentInitializzed") {
        if (this.partnerData.isPartner) {
          const newNicaForm = res.component || undefined
          const elementRefs = newNicaForm.elementRef || undefined
          if (newNicaForm && elementRefs) {
            let partnerExcludeInput = ['procedura_attiva', 'Motivazione', 'Licenza', 'Assistenza', 'keycode', 'RateoIniziale', 'rata1', 'rata2', 'rata3', 'rata4', 'note']
            if (newNicaForm.isEdit === true) {
              partnerExcludeInput = [...partnerExcludeInput, ...['CodSede', 'CodProcedura', 'CodModulo', 'dataScadenza', 'dataAttivazione']]
            }
            console.log(elementRefs)
            Object.keys(elementRefs).forEach(key => {
              if (partnerExcludeInput.some(ex => key.includes(ex))) {
                if (elementRefs[key].onInitialized !== null) {
                  elementRefs[key].onInitialized.component.option('disabled', true)
                } else {
                  elementRefs[key].htmlElement.disabled = true
                }
                elementRefs[key].editorComponent.showClearButton = false
                elementRefs[key].editorComponent.buttonTextArea = false
                if (elementRefs[key].editorComponent.buttonOptionType2 && elementRefs[key].editorComponent.buttonOptionType2.length > 0) {
                  elementRefs[key].editorComponent.buttonOptionType2 = []
                }
                if (elementRefs[key].editorComponent.buttonOption && elementRefs[key].editorComponent.buttonOption.length > 0) {
                  elementRefs[key].editorComponent.buttonOption = []
                }
              }

            });
          }
        }
      }
      // this.onAllEventGrid(res)

    })
  }

  calcolaRateo(res) {
    //console.log(res)
    let message = ''
    if (res.data && res.component) {
      const component = res.component as NewNicaFormComponent
      const Assistenza = res.data.Assistenza
      if (Assistenza !== null && Assistenza !== '') {
        const dataAttivazione = res.data.dataAttivazione
        const dataScadenza = res.data.dataScadenza
        if (dataAttivazione !== null && dataScadenza !== null && dataAttivazione !== '' && dataScadenza !== '') {
          const diffGiorniDate = parseInt(this.moment(dataScadenza).diff(this.moment(dataAttivazione), 'day'))
          const prezzoXGiorno = parseInt(Assistenza) / 365
          //console.log(prezzoXGiorno)
          //console.log(diffGiorniDate)
          const RateoIniProposto = (prezzoXGiorno * diffGiorniDate).toFixed(0)
          //console.log(RateoIniProposto)
          component.dataSet['RateoIniziale'] = RateoIniProposto
        } else {
          message = 'I campi delle  date devono essere entrambi compilati'
          return alert(message, 'Attenzione')
        }
      } else {
        message = 'Il campo assistenza deve essere compilato'
        return alert(message, 'Attenzione')
      }
    }
    //console.log('calcolaRateo')
    return
  }
}


